import React, { lazy, Suspense } from 'react';
import ModalSpinner from '../viewers/modalSpinner';
import { MediaViewerPortal } from './portal';
var MediaViewer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_media-viewer" */'./media-viewer-error-boundary').then(function (_ref) {
    var MediaViewerWithErrorBoundary = _ref.MediaViewerWithErrorBoundary;
    return {
      default: MediaViewerWithErrorBoundary
    };
  });
});
export default function AsyncMediaViewer(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(ModalSpinner, null)
  }, /*#__PURE__*/React.createElement(MediaViewerPortal, null, /*#__PURE__*/React.createElement(MediaViewer, props)));
}